export default __webpack_public_path__ + "static/media/set_remote_on_icon.20393145.svg";